export enum Source {
  GENERAL = "general",
  WELLHUB = "wellhub",
  GYMPASS = "gympass",
  CLARAINE = "clariane",
  IDEALISTA = "idealista",
}
